module.exports = __webpack_public_path__ + "img/loading-spin.e69f2e74.svg";